const BASE_URL = window.base_url;
const BASE_API_URL = window.base_url_api;

export {
    BASE_URL,
    BASE_API_URL
}


// WEBPACK FOOTER //
// ./src/Components/App/App.Settings.jsx